export const COMMIT_FETCH_TIMEOUT = 45_000;

export type DocsConversionType = 'txt' | 'md' | 'html' | 'json' | 'docx' | 'xlsx' | 'csv' | 'tsv';

export type SpreadsheetConversionType = 'xlsx' | 'csv' | 'tsv';
